import { Group, Title, Text, Stack, Breadcrumbs, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

export default function PageHeader({ title, description, actions, breadcrumbs }: PageHeaderProps) {
  return (
    <Group justify="space-between" align="flex-start">
      <Stack gap={4}>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs
            separator="/"
            aria-label="Breadcrumb navigation"
            styles={{ separator: { opacity: 0.5 } }}
          >
            {breadcrumbs.map((crumb, i) =>
              crumb.path ? (
                <Anchor component={Link} to={crumb.path} size="sm" key={i}>
                  {crumb.label}
                </Anchor>
              ) : (
                <Text size="sm" key={i}>{crumb.label}</Text>
              )
            )}
          </Breadcrumbs>
        )}
        <Title order={2}>{title}</Title>
        {description && (
          <Text c="dimmed" size="sm">
            {description}
          </Text>
        )}
      </Stack>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
}
